<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="6.99792"
      y="6.99805"
      width="14.0058"
      height="14.0058"
      rx="2"
      stroke="currentColor"
      fill="none"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.99791 17.0024H4.99708C3.89205 17.0024 2.99625 16.1066 2.99625 15.0016V4.99742C2.99625 3.89239 3.89205 2.99658 4.99708 2.99658H15.0012C16.1063 2.99658 17.0021 3.89239 17.0021 4.99742V6.99825"
      stroke="currentColor"
      fill="none"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
